// extracted by mini-css-extract-plugin
module.exports = {"note":"Plan-note-2yRMsL_fiY"};